module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-image05-1110x550@2x.c8bd4bef.jpg";